<div class="modal-header">
  <h4 class="modal-title">
    {{ "campaignDetails.updateStatusCampaign" | translate }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()"
  ></button>
</div>
<div class="modal-body">
  <div *ngIf="form.get('status')?.value === campaignStatusEnum.FINISHED && detailsAd.objectiveName === objectiveTypeEnum.GENERATION_DE_PROSPECTS && !detailsAd.responsesFile">
    <span
      class="d-flex text-wrap align-items-baseline"
      [ngClass]="'alert'"
      style="background-color: #FFE899; color: #E56B00; border-radius: 4.45px;"
    >
      <i class="icofont icofont-info-circle"></i>
      <div class="lh-base">
        <span>
          {{ "warningMessages.noResponsesFileUploaded" | translate }}.
          <a (click)="openUploadModal()" type="button" style="text-decoration: underline;"> <b>{{ "warningMessages.uploadFileLink" | translate }}</b> </a>.
        </span>
      </div>
    </span>
  </div>
  <form [formGroup]="form">
    <div class="form-group">
      <label class="label">{{ "updateStatus.status" | translate }} *</label>
      <div class="input-group">
        <select
          class="form-select form-control digits"
          formControlName="status"
          required=""
        >
          <option [ngValue]="null">
            {{ "updateStatus.selectStatus" | translate }}
          </option>
          <option
            class="form-select"
            *ngFor="let status of campaignStatus"
            [ngValue]="status.id"
            selected="status.id == adDetails.status"
          >
            {{ status.value | translate }}
          </option>
        </select>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="closeModal()">
    {{ "buttons.close" | translate }}
  </button>
  <button class="btn btn-primary" (click)="updateStatus()">
    <loading-button
      [loading]="loading"
      [value]="'buttons.confirm'"
      [icon]="null"
    ></loading-button>
  </button>
</div>
